import { render, staticRenderFns } from "./ChatInputArea.vue?vue&type=template&id=6b1f51ec&scoped=true&"
import script from "./ChatInputArea.vue?vue&type=script&lang=ts&"
export * from "./ChatInputArea.vue?vue&type=script&lang=ts&"
import style0 from "./ChatInputArea.vue?vue&type=style&index=0&id=6b1f51ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1f51ec",
  null
  
)

export default component.exports